import script from "./CollapseItem.vue?vue&type=script&setup=true&lang=js"
export * from "./CollapseItem.vue?vue&type=script&setup=true&lang=js"

import "./CollapseItem.vue?vue&type=style&index=0&id=46d679e4&scoped=true&lang=css"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46d679e4"]])

export default __exports__